// extracted by mini-css-extract-plugin
export var centerText = "_74-8";
export var container = "_74-0";
export var doughnutContainer = "_74-7";
export var legend = "_74-a";
export var legendItemColorDisplay = "_74-b";
export var legendItemLabel = "_74-d";
export var legendItemValue = "_74-c";
export var lg = "_74-5";
export var maxWidth = "_74-9";
export var md = "_74-4";
export var responsive = "_74-6";
export var sm = "_74-3";
export var xs = "_74-2";
export var xxs = "_74-1";